import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home, meta: {

      public: true,
      transition: 'zoom'
  }

  },{
    breadcrumb: 'Dashboard',
    path: "/dashboard/dashboard1",
    name: "Dashboard1",
    component: () =>
        import ('@/views/dashboard/Dashboard1.vue'),
    meta: {
        breadcrumb: true,

    }
},  {
  path: '/dashboard/dashboard2',
  name: 'Dashboard2',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/Dashboard2.vue'), meta: {
    breadcrumb: true,

}
} ,{
  path: '/trader/exchange',
  name: 'Exchange',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" */ '../views/trader/Exchange.vue'), meta: {
    breadcrumb: true,

}
} ,{
  path: '/trader/market',
  name: 'Market',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" */ '../views/trader/Market.vue'), meta: {
    breadcrumb: true,

}
} ,{
  path: '/trader/portfolio',
  name: 'Portfolio',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" */ '../views/trader/Portfolio.vue'), meta: {
    breadcrumb: true,

}
} ,{
  path: '/trader/transactions',
  name: 'Transactions',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" */ '../views/trader/Transactions.vue'), meta: {
    breadcrumb: true,

}
} ,,{
  path: "/ui/alert",
  name: "Alert",
  component: () =>
      import ('@/views/ui/Alert.vue'),
  meta: {
      breadcrumb: true,
  }
},,{
  path: "/ui/list",
  name: "List",
  component: () =>
      import ('@/views/ui/List.vue'),
  meta: {
      breadcrumb: true,
  }
},


{
  path: "/ui/buttons",
  name: "Buttons",
  component: () =>
      import ('@/views/ui/Buttons.vue'),
  meta: {
      breadcrumb: true,
  }
},


{
  path: "/ui/cards",
  name: "Cards",
  component: () =>
      import ('@/views/ui/Cards.vue'),
  meta: {
      breadcrumb: true,
  }
},

{
  path: "/ui/carousels",
  name: "Carousels",
  component: () =>
      import ('@/views/ui/Carousels.vue'),
  meta: {
      breadcrumb: true,
  }
},
 {
  path: "/ui/footers",
  name: "Footers",
  component: () =>
      import ('@/views/ui/Footers.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/ui/steppers",
  name: "Steppers",
  component: () =>
      import ('@/views/ui/Steppers.vue'),
  meta: {
      breadcrumb: true,
  }
},{
  path: "/ui/chips",
  name: "Chips",
  component: () =>
      import ('@/views/ui/Chips.vue'),

  meta: {
      breadcrumb: true,
  }
},


{
  path: "/ui/hover",
  name: "Hover",
  component: () =>
      import ('@/views/ui/Hover.vue'),

  meta: {
      breadcrumb: true,
  }
},

{
  path: "/ui/images",
  name: "Images",
  component: () =>
      import ('@/views/ui/Images.vue'),

  meta: {
      breadcrumb: true,
  }
},

{
  path: "/ui/parallax",
  name: "Parallax",
  component: () =>
      import ('@/views/ui/Parallax.vue'),
  meta: {
      breadcrumb: true,
  }
},

{
  path: "/ui/progressbar",
  name: "Progressbar",
  component: () =>
      import ('@/views/ui/Progressbar.vue'),

  meta: {
      breadcrumb: true,
  }
},

{
  path: "/ui/tabs",
  name: "Tabs",
  component: () =>
      import ('@/views/ui/Tabs.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/ui/tooltip",
  name: "Tooltip",
  component: () =>
      import ('@/views/ui/Tooltip.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/ui/typography",
  name: "Typography",
  component: () =>
      import ('@/views/ui/Typography.vue'),
  meta: {
      breadcrumb: true,
  }
},
{
  path: "/charts/echarts",

  name: "Echarts",
  component: () =>
      import ('@/views/charts/Echarts.vue'),
  meta: {
      breadcrumb: true,
  }
},
{
  path: "/charts/chart-js",

  name: "ChartJs",
  component: () =>
      import ('@/views/charts/ChartJs.vue'),
  meta: {
      breadcrumb: true,
  }
},

{
  path: "/charts/morris",

  name: "Morris",
  component: () =>
      import ('@/views/charts/Morris.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/charts/apexcharts",
  name: "Apexcharts",
  component: () =>
      import ('@/views/charts/Apexcharts.vue'),

  meta: {
      breadcrumb: true,
  }
},

{
  path: "/charts/c3",
  name: "C3",
  component: () =>
      import ('@/views/charts/C3.vue'),

  meta: {
      breadcrumb: true,
  }
},
{
  path: "/charts/ricksaw",
  name: "Ricksaw",
  component: () =>
      import ('@/views/charts/Ricksaw.vue'),
  meta: {
      breadcrumb: true,
  }
},

{
  path: "/apps/calendar",
  name: "Calendar",
  component: () =>
      import ('@/views/apps/Calendar.vue'),
  meta: {
      breadcrumb: true,
  }
},
 {
  path: "/users/video-call",
  name: "VideoCall",
  component: () =>
      import ('@/views/users/VideoCall.vue'),

  meta: {
      breadcrumb: true,
  }
},
 {
  path: "/apps/inbox",
  name: "Inbox",
  component: () =>
      import ('@/views/apps/Inbox.vue'),
  meta: {
    breadcrumb: true,
  }
}, {
  path: "/users/profile",
  name: "Profile",
  component: () =>
      import ('@/views/users/Profile.vue'),
  meta: {
      breadcrumb: true,
  }
},
{
  path: "/users/projects",
  name: "Projects",
  component: () =>
      import ('@/views/users/Projects.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/users/settings",
  name: "Settings",
  component: () =>
      import ('@/views/users/Settings.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/users/contact",
  name: "Contact",
  component: () =>
      import ('@/views/users/Contact.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/apps/file-manager",
  name: "FileManager",
  component: () =>
      import ('@/views/apps/FileManager.vue'),
  meta: {
      breadcrumb: true,
  }
}, {
  path: "/apps/invoice",
  name: "Invoice",
  component: () =>
      import ('@/views/apps/Invoice.vue'),
  meta: {
      breadcrumb: true,
  }
}, {

    name: "WidgetCharts",
    path: "/widgets/widget-charts",
    component: () =>
        import ('@/views/widgets/WidgetCharts.vue'),
    meta: {
        breadcrumb: true,
    }
},{

    name: "WidgetList",
    path: "/widgets/widget-List",
    component: () =>
        import ('@/views/widgets/WidgetList.vue'),
    meta: {
        breadcrumb: true,
    }
},{


  path: "/apps/draggable",
  name: "Draggable",
  component: () =>
      import ('@/views/apps/Draggable.vue'),
  meta: {
      breadcrumb: true,
  }
},{


  path: "/apps/pricing",
  name: "Pricing",
  component: () =>
      import ('@/views/apps/Pricing.vue'),
  meta: {
      breadcrumb: true,
  }
},{


  path: "/apps/sweet-alert",
  name: "SweetAlert",
  component: () =>
      import ('@/views/apps/SweetAlert.vue'),
  meta: {
      breadcrumb: true,
  }
},{


  path: "/apps/todo-list",
  name: "TodoList",
  component: () =>
      import ('@/views/apps/TodoList.vue'),
  meta: {
      breadcrumb: true,
  }
},{
  path: "/apps/timeline",
  name: "Timeline",
  component: () =>
      import ('@/views/apps/Timeline.vue'),
  meta: {
      breadcrumb: true,
  }
},{


  path: "/apps/loading",
  name: "Loading",
  component: () =>
      import ('@/views/apps/Loading.vue'),
  meta: {
      breadcrumb: true,
  }
},{

  name: "PageLogin",
  path: "/pages/page-login",
  component: () =>
      import ('@/views/pages/PageLogin.vue'),
  meta: {
      public: true,
  }
},
{

  name: "PageEmpty",
  path: "/pages/page-empty",
  component: () =>
      import ('@/views/pages/PageEmpty.vue'),
  meta: {
      breadcrumb: true,
  }
},  {

  name: "PageFaq",
  path: "/pages/page-faq",
  component: () =>
      import ('@/views/pages/PageFaq.vue'),
  meta: {
      breadcrumb: true,
  }
},

{

  name: "PageRegister",
  path: "/pages/page-register",
  component: () =>
      import ('@/views/pages/PageRegister.vue'),
  meta: {
      public: true,
  }
},   {

  name: "PageError",
  path: "/pages/page-error",
  component: () =>
      import ('@/views/pages/PageError.vue'),
  meta: {
      public: true,
  }
}, {
  path: "/tables/table-simple",
  name: "TableSimple",
  component: () =>
      import ('@/views/tables/TableSimple.vue'),
  meta: {
      breadcrumb: true,
  }
},
{
  path: "/tables/table-datatable",
  name: "TableDatatable",
  component: () =>
      import ('@/views/tables/TableDatatable.vue'),

  meta: {
      breadcrumb: true,
  }
}, {
  path: "/tables/data-iterators",
  name: "DataIterators",
  component: () =>
      import ('@/views/tables/DataIterators.vue'),

  meta: {
      breadcrumb: true,
  }
}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // this allows your SPA to act more like a traditional webpage allowing the user to use back and forward buttons
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

export default router
